module.exports = __webpack_public_path__ + "img/45.4.NH3-N.7b65bc66.png";